/* eslint-disable react/prop-types */
import React from "react";
import { useHistory } from "react-router-dom";

import { usePageContext } from "components/Context";

import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

import MenuIcon from "@material-ui/icons/Menu";
import {
  HomeIcon,
  PowerSettingsIcon,
  UpgradeIcon,
} from "components/VivialIcons";

import VivialConnectAPI from "api/vivial-connect";

import { useStyles } from "./styles";

export default function MainAppBar(props) {
  const { pageState } = usePageContext();
  const classes = useStyles();
  const history = useHistory();
  const isLogged = VivialConnectAPI.helpers.token.get();
  const { handleDrawerToggle } = props;

  const redirectToURL = (url) => () => {
    history.push(url);
  };

  return (
    <AppBar position="absolute" className={classes.appBar} color="inherit">
      <Toolbar className={classes.toolbar}>
        <Hidden mdUp>
          <IconButton
            aria-label="show menu"
            onClick={handleDrawerToggle}
            className={classes.drawerToggle}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>

        <div className={classes.title}>
          <Typography
            component="h1"
            variant="h4"
            noWrap
            className={classes.typography}
          >
            {pageState.title || ""}
          </Typography>
          <Hidden smDown>
            {pageState.subtitle ? (
              <Box className={classes.box}>
                <Typography
                  component="h2"
                  variant="h6"
                  noWrap
                  className={`${classes.typography} ${classes.subTitle}`}
                >
                  {pageState.subtitle}
                </Typography>
              </Box>
            ) : null}
          </Hidden>
        </div>

        <div className={classes.menuItems}>
          {isLogged ? (
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={redirectToURL("/dashboard")}
            >
              <HomeIcon className={classes.menuIconPower} />
              <Typography
                type="body1"
                style={{
                  marginLeft: 4,
                }}
              >
                Dashboard
              </Typography>
            </IconButton>
          ) : (
            <>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={redirectToURL("/register")}
              >
                <UpgradeIcon className={classes.menuIconPower} />
                <Typography
                  type="body1"
                  style={{
                    marginLeft: 4,
                  }}
                >
                  Sign Up
                </Typography>
              </IconButton>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={redirectToURL("/login")}
              >
                <PowerSettingsIcon className={classes.menuIconPower} />
                <Typography
                  type="body1"
                  style={{
                    marginLeft: 4,
                  }}
                >
                  Login
                </Typography>
              </IconButton>
            </>
          )}
        </div>
      </Toolbar>
    </AppBar>
  );
}
